import * as React from 'react';
import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint, Color, IconName } from '../../enums';
import { Breadcrumb } from '../../interfaces';

import { BreadcrumbLinkWithIcon, BreadcrumbItem, Container, StyledIcon } from './breadcrumbs.styled';
import { BreadcrumbsProps } from './breadcrumbs.types';

export const Breadcrumbs: React.FC<BreadcrumbsProps> = (props: BreadcrumbsProps): JSX.Element => {
  const { breadcrumbs, mobileFullSize = false, className }: BreadcrumbsProps = props;
  const isSmallMobile: boolean = useMediaQuery({ query: Breakpoint.SmallMobile });

  const isWithCustomActive: boolean = useMemo((): boolean => {
    return !!breadcrumbs.find((breadcrumb: Breadcrumb): boolean => !!breadcrumb.active);
  }, [breadcrumbs]);

  return (
    <Container className={className}>
      {!isSmallMobile || !!mobileFullSize ? (
        <>
          {breadcrumbs.map((breadcrumb: Breadcrumb, index: number): JSX.Element => (
            <React.Fragment key={breadcrumb.label}>
              <BreadcrumbItem
                to={breadcrumb.path}
                $active={isWithCustomActive ? !!breadcrumb.active : index === breadcrumbs.length - 1}
              >
                {breadcrumb.label}
              </BreadcrumbItem>
              {index < breadcrumbs.length - 1 && (
                <StyledIcon
                  name={IconName.ArrowRight25}
                  size={10}
                  color={Color.Gray500}
                />
              )}
            </React.Fragment>
          ))}
        </>
      ) : (
        <>
          <BreadcrumbLinkWithIcon to={breadcrumbs[breadcrumbs.length >= 2 ? breadcrumbs.length - 2 : breadcrumbs.length - 1].path}>
            <StyledIcon
              name={IconName.ArrowLeft25}
              size={10}
              color={Color.Gray500}
            />
          </BreadcrumbLinkWithIcon>
          <BreadcrumbItem
            to={breadcrumbs[breadcrumbs.length - 1].path}
            $active
          >
            {breadcrumbs[breadcrumbs.length - 1].label}
          </BreadcrumbItem>
        </>
      )}
    </Container>
  );
};
